/**
 * "4/12 attempted" chip for a trainee row. Click opens the trainee's
 * assessment history (dashboard dialog, scrolled to Assessments).
 */
import { ClipboardCheck } from 'lucide-react';

export function AttemptedChip({ coverage, onClick, testId }) {
  if (!coverage) return <span className="text-xs text-muted-foreground">—</span>;
  const { attempted, assigned } = coverage;
  if (assigned === 0) {
    return <span className="text-xs text-muted-foreground" data-testid={testId}>None assigned</span>;
  }
  const full = attempted >= assigned;
  const none = attempted === 0;
  const tone = full ? 'border-emerald-300 bg-emerald-50 text-emerald-800'
    : none ? 'border-border bg-muted/40 text-muted-foreground'
    : 'border-amber-300 bg-amber-50 text-amber-800';
  return (
    <button type="button" onClick={onClick} data-testid={testId}
            title="Open assessment history"
            className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-display tabular-nums
                        transition-colors hover:border-primary hover:text-primary ${tone}`}>
      <ClipboardCheck className="w-3 h-3" />
      {attempted}/{assigned} attempted
    </button>
  );
}
